import { getAwsAssets } from "@src/utils";
import React from "react";
import styles from "./CouponModal.module.scss";
import { t } from "i18next";

function CouponModal({ onClose }) {
  return (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <img
          src={getAwsAssets("yellowAlertIcon.svg", "layout")}
          alt=""
          className={styles.image}
        />
        <div className={styles.info}>
          <div className={styles.heading}>
            {t(
              "components.tabs.overview.components.multipleValidity.couponModal.couponText",
              "Coupon Code Not Applicable"
            )}
          </div>
          <div className={styles.description}>
            {t(
              "components.tabs.overview.components.multipleValidity.couponModal.couponDescription",
              "Applied coupon code is not applicable. Please select a different coupon from available offers to unlock discounts"
            )}
          </div>
        </div>
        <div className={styles.okayButton} onClick={onClose}>
          {t(
            "components.tabs.overview.components.multipleValidity.couponModal.buttonText",
            "OKAY"
          )}
        </div>
      </div>
    </div>
  );
}

export default CouponModal;
